'use strict';
import { j as t } from "../../external/react/jsx-runtime.js";
import { useState as o } from "react";
import m from "../Modal/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faFileCircleCheck as f } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import "../../external/base-64/base64.js";
import "../../external/js-cookie/dist/js.cookie.js";
import { formatBytes as p } from "../../helpers/numberUtils.js";
import { imageContentTypes as x } from "./ChatContainer.js";
import d, { Element as n, domToReact as l } from "html-react-parser";
const O = ({
  message: e,
  onOpenImage: c,
  onOpenFile: i
}) => {
  const [s, a] = o(!1);
  return e.content ? e.contentCreator === "User" || e.contentCreator === "System Generated" ? e.content : d(e.content, {
    replace: (r) => {
      if (r instanceof n && r.name === "p")
        return /* @__PURE__ */ t.jsx("p", { className: "[&>a]:underline", children: l(r.children) });
      if (r instanceof n && r.name === "ol")
        return /* @__PURE__ */ t.jsx("ol", { className: "list-decimal ml-4 mb-4 pl-4", children: l(r.children) });
      if (r instanceof n && r.name === "ul")
        return /* @__PURE__ */ t.jsx("ul", { className: "list-disc ml-4 mb-4 pl-4", children: l(r.children) });
    }
  }) : e.attachment ? e.attachmentExtension && x.includes(e.attachmentExtension) ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      "span",
      {
        className: "cursor-pointer",
        onClick: () => {
          c(), a(!0);
        },
        children: /* @__PURE__ */ t.jsx(
          "img",
          {
            className: "rounded-lg",
            src: e.attachment,
            alt: e.attachmentFileName || ""
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      m,
      {
        isOpen: s,
        onModalClose: () => a(!1),
        className: "w-full h-full",
        shouldCloseOnOverlayClick: !0,
        children: /* @__PURE__ */ t.jsx("div", { className: "md:pt-8", children: /* @__PURE__ */ t.jsx(
          "a",
          {
            href: e.attachment,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /* @__PURE__ */ t.jsx(
              "img",
              {
                className: "w-full h-full object-contain max-h-[calc(90vh_-_5rem)]",
                src: e.attachment,
                alt: e.attachmentFileName || ""
              }
            )
          }
        ) })
      }
    )
  ] }) : /* @__PURE__ */ t.jsxs(
    "a",
    {
      className: "flex flex-row gap-2",
      href: e.attachment,
      onClick: () => {
        i();
      },
      children: [
        /* @__PURE__ */ t.jsx("span", { className: "flex items-center justify-center rounded-lg bg-white text-grey-400 py-2 px-3", children: /* @__PURE__ */ t.jsx(h, { icon: f }) }),
        /* @__PURE__ */ t.jsxs("span", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ t.jsx("span", { className: "p2 text-white", children: e.attachmentFileName }),
          /* @__PURE__ */ t.jsx("span", { className: "p2 text-white", children: p(e.attachmentSize) })
        ] })
      ]
    }
  ) : null;
};
export {
  O as default
};
